export default __webpack_public_path__ + "static/media/GT.a208122c.svg";